import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectorModel } from 'src/app/fragments/selector/selector-model';
import { SelectorComponent } from 'src/app/fragments/selector/selector.component';
import { FilterModel } from '../../model/filter-model';
import { QueryElementsConfig } from '../../model/query-elements-config';

@Component({
  selector: 'app-video-query-elements',
  templateUrl: 'video-query-elements.component.html',
  styleUrls: ['video-query-elements.component.scss'],
  standalone: true,
  imports: [
    CommonModule, FormsModule,
    SelectorComponent
  ],
})
export class VideoQueryElementsComponent implements OnInit, AfterViewInit {

  @Input() accentColorInHex: string = '#007bff';
  @Input() allowEmptyValues: boolean = true;

  @Input() queryElementsConfig: QueryElementsConfig = {
    gender: { visible: true },
    category: { visible: true },
    competition: { visible: true },
    championship: { visible: true },
    dateStart: { visible: true },
    dateEnd: { visible: true },
  };
  @Output() queryElementsConfigChange: EventEmitter<QueryElementsConfig> = new EventEmitter();


  @Input() filters: FilterModel;
  @Output() filtersChange: EventEmitter<FilterModel | null> = new EventEmitter();

  selectedGender: SelectorModel;
  genderOptions: SelectorModel[] = [];

  selectedCategory: SelectorModel;
  categoryOptions: SelectorModel[] = [];

  selectedCompetition: SelectorModel;
  competitionOptions: SelectorModel[] = [];

  selectedChampionship: SelectorModel;
  championshipOptions: SelectorModel[] = [];

  dateStart: string = '';
  dateEnd: string = '';

  constructor() { }

  ngOnInit() {
    this.loadData();
    this.updateFilters();
  }

  ngAfterViewInit() {
    this.updateFilters();
  }

  protected updateFilters() {
    if (!this.filters) {
      this.filters = {
        gender: this.genderOptions[0].value,
        category: this.categoryOptions[0].value,
        competition: this.competitionOptions[0].value,
        championship: this.championshipOptions[0].value,
        dateStart: '',
        dateEnd: ''
      }
    }

    this.filters.gender = this.selectedGender?.value || this.genderOptions[0].value;
    this.filters.category = this.selectedCategory?.value || this.categoryOptions[0].value;
    this.filters.competition = this.selectedCompetition?.value || this.competitionOptions[0].value;
    this.filters.championship = this.selectedChampionship?.value || this.championshipOptions[0].value;
    this.filters.dateStart = this.dateStart || '';
    this.filters.dateEnd = this.dateEnd || '';


    this.filtersChange.emit(this.filters);
  }

  protected getOption(value: string, options: SelectorModel[]): SelectorModel | undefined {
    return options.find(option => option.value === value);
  }

  protected onQueryElementsOpen(key: string | null | undefined, value: boolean) {

    // Toggle all other query elements to false
    for (const k in this.queryElementsConfig) {
      if (this.queryElementsConfig.hasOwnProperty(k) && k !== key) {
        this.queryElementsConfig[k].isOpen = false;
      }
    }

    if (key) {
      // Toggle the selected query element
      this.queryElementsConfig[key].isOpen = value;

    }

    this.queryElementsConfigChange.emit(this.queryElementsConfig);
  }

  protected loadData() {
    this.genderOptions = [
      { id: 'masc', label: 'Masculino', value: 'MASCULINO' },
      { id: 'fem', label: 'Femenino', value: 'FEMENINO' },
      { id: 'mix', label: 'Mixto', value: 'MIXTO' },
    ];

    if (this.queryElementsConfig.gender.allowOtherCustomField) {
      this.genderOptions.push({ id: 'other', label: 'Otro (crear)', value: 'other' });
    }

    this.categoryOptions =
      [
        { id: 'senior', label: 'Senior', value: 'Senior' },
        { id: 'junior', label: 'Junior', value: 'Junior' },
        { id: 'juvenil', label: 'Juvenil', value: 'Juvenil' },
        { id: 'promesas', label: 'Promesas', value: 'Promesas' },
      ];

    if (this.queryElementsConfig.category.allowOtherCustomField) {
      this.categoryOptions.push({ id: 'other', label: 'Otro (crear)', value: 'other' });
    }

    this.competitionOptions =
      [
        { id: 'seleccion', label: 'Selección', value: 'Selección' },
        { id: 'clubes', label: 'Clubes', value: 'Clubes' },
      ];

    if (this.queryElementsConfig.competition.allowOtherCustomField) {
      this.competitionOptions.push({ id: 'other', label: 'Otro (crear)', value: 'other' });
    }

    this.championshipOptions = [
      { id: 'mundial', label: 'Mundial', value: 'Mundial' },
      { id: 'europeo', label: 'Europeo', value: 'Europeo' },
      { id: 'olimpiadas', label: 'Olimpíadas', value: 'Olimpíadas' },
      { id: 'amistoso', label: 'Amistoso', value: 'Amistoso' },
    ];

    if (this.queryElementsConfig.championship.allowOtherCustomField) {
      this.championshipOptions.push({ id: 'other', label: 'Otro (crear)', value: 'other' });
    }

    if (this.allowEmptyValues) {
      this.genderOptions.unshift({ id: '', label: 'Todos', value: '' });
      this.categoryOptions.unshift({ id: '', label: 'Todos', value: '' });
      this.competitionOptions.unshift({ id: '', label: 'Todos', value: '' });
      this.championshipOptions.unshift({ id: '', label: 'Todos', value: '' });
    }
  }

}
